/**
 * ToolCallCard — generic inline tool call status card.
 * Shown for tool names that don't have a dedicated card component.
 * [Source: Story P1b spec §8]
 */
import type { BrokUiMessage } from '../brok-chat.types';
import { Card } from '../../../components/ui/Card';
import { Badge } from '../../../components/ui/Badge';

type ToolMsg = Extract<BrokUiMessage, { kind: 'tool' }>;

export function ToolCallCard({ msg }: { msg: ToolMsg }) {
  return (
    <Card className="p-3 text-xs">
      <div className="mb-1 flex items-center gap-2">
        <span className="font-medium">{msg.toolName}</span>
        {msg.status === 'running' ? (
          <Badge variant="info">Brok prüft …</Badge>
        ) : (
          <Badge variant="ok">Fertig</Badge>
        )}
      </div>
      {msg.status === 'done' && msg.result != null && (
        <pre className="mt-1 max-h-32 overflow-auto rounded bg-muted p-2 text-[10px] text-muted-foreground">
          {JSON.stringify(msg.result, null, 2)}
        </pre>
      )}
    </Card>
  );
}
